module.exports = __webpack_public_path__ + "b2feb1c702b9b4c46343cfc222770c0d.svg";